<template>
  <div class="page">
    <strong style="font-size: 20px;">订单信息</strong>
    <div class="order1">
      <div class="user">
        <div style="width: 50%;">
          <div style="margin-bottom: 10px;">收件人: {{ addressInfo.name }}</div>
          <div style="margin-bottom: 10px;">电话: {{ addressInfo.mobile }}</div>
          <div style="margin-bottom: 10px;">
            邮编: {{ addressInfo.post_code }}
          </div>
        </div>
        <div style="width: 50%;">
          <div style="margin-bottom: 10px;">
            所在地区: {{ addressInfo.showAddress }}
          </div>
          <div style="margin-bottom: 10px;">
            详细地址: {{ addressInfo.address }}
          </div>
        </div>
      </div>
      <div class="orderList" v-for="it in list">
        <div class="order_sn" style="font-size: 14px;">
          <div>订单号: {{ it.ordersn }}</div>
          <div>创建时间: {{ it.create_time | dataFormat }}</div>
        </div>
        <div class="orderList_item">
          <div class="goods" style="width: 30%; display: flex;">
            <img class="goods_img" :src="it.goods_img" />
            <div>
              <div style="margin-bottom: 10px;">{{ it.goods_name }}</div>
              <div style="color: #3c3c3c;">{{ it.goods_sku_name }}</div>
            </div>
          </div>
          <div class="goods center">
            <div style="text-align: center;">
              <div>¥{{ it.goods_price }}</div>
            </div>
          </div>
          <div class="goods center">
            <div>x {{ it.goods_num }}</div>
          </div>
          <div class="goods center">
            <div style="text-align: center; font-size: 14px;">
              <div>使用积分{{ it.use_point }}</div>
              <div>积分抵扣{{ it.point_dec_money }}元</div>
              <div>邮费使用积分{{ it.ship_use_point }}</div>
              <div>积分抵扣邮费{{ it.ship_dec_money }}元</div>
            </div>
          </div>
          <div class="goods center">
            <div>{{ it.status_text }}</div>
          </div>
          <div class="goods center">
            <div style="text-align: center;">
              <strong>
                ¥{{ (Number(it.amount) + Number(it.ship_amount)).toFixed(2) }}
              </strong>
              <div style="color: #6c6c6c;">(含快递:¥{{ it.ship_amount }})</div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 10px 0;
        "
      >
        <div></div>
        <div>
          <div>
            应付:
            <strong style="font-size: 20px; font-weight: bolder;">
              ¥{{ Info.money }}
            </strong>
          </div>
          <div>
            实付:
            <span style="font-size: 20px; color: red; font-weight: bolder;">
              ¥{{ (Number(Info.amount) + Number(Info.ship_amount)).toFixed(2) }}
            </span>
            (含快递:¥{{ Info.ship_amount }})
          </div>
          <div>使用积分:{{ Info.use_point }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IntegralOrder_Info } from '@/api/integralMall'
export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  data() {
    return {
      Info: {},
      addressInfo: {},
      list: [],
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      const res = await IntegralOrder_Info({
        app_id: this.app_id,
        group_id: this.$route.query.id,
      })
      console.log(res)
      this.Info = res.data
      this.addressInfo = res.data.ship_address
      this.addressInfo.showAddress = `${res.data.ship_address.province}${res.data.ship_address.city}${res.data.ship_address.area}${res.data.ship_address.town}`
      this.list = res.data.list
    },
  },
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
.order1 {
  width: 90%;
  position: relative;
  top: 10px;
  margin-bottom: 40px;
  border: 1px solid #aec7e5;
  clear: both;
  height: auto;
  overflow: hidden;
  padding: 10px 20px;
  font-size: 18px;
  .user {
    width: 100%;
    display: flex;
  }
}

.top {
  width: 100%;
  background: #f9f9f9;
  padding: 10px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #ececec;
  color: #3c3c3c;
  margin-bottom: 10px;
}
.top > div {
  width: 10%;
  text-align: center;
}
.orderList {
  width: 100%;
  margin-bottom: 5px;
  //border: 1px solid #ececec;
  .orderList_top {
    font-size: 16px;
    padding: 8px 10px;
    background: #eaf8ff;
    display: flex;
    justify-content: space-between;
    div {
      //width: 20%;
      margin-right: 20px;
      display: flex;
      justify-content: center;
    }
  }
  .order_sn {
    width: 100%;
    border: 1px solid #ececec;
    padding: 10px 10px;
    border-bottom: none;
    display: flex;
    div {
      margin-right: 20px;
    }
  }
  .orderList_item {
    width: 100%;
    border: 1px solid #ececec;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    padding: 5px 0;
    font-size: 16px;
    .goods {
      width: 10%;
      display: flex;
      .goods_img {
        width: 30%;
        height: 130px;
        margin-right: 10px;
      }
    }
    .center {
      display: flex;
      justify-content: center;
    }
  }
}
::v-deep.el-button {
  padding: 0;
}
</style>
